import { Component, OnInit, Type } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EHomeValues } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { AdminHomeAssetsComponent } from './admin-home-assets/admin-home-assets.component';
import { AdminHomeProjectsComponent } from './admin-home-projects/admin-home-projects.component';
import { AdminHomePurchasesComponent } from './admin-home-purchases/admin-home-purchases.component';
import {AdminHomeProductsComponent} from "./admin-home-products/admin-home-products.component";

export interface HomeTab {
  id: number;
  name: string;
  title: string;
  component: Type<unknown>;
}

const HOME_COMPONENTS: Record<string, Type<unknown>> = {
  projects: AdminHomeProjectsComponent,
  assets: AdminHomeAssetsComponent,
  purchases: AdminHomePurchasesComponent,
  products: AdminHomeProductsComponent,
};

@Component({
    selector: 'app-admin-homes',
    templateUrl: './admin-homes.component.html',
    styleUrls: ['./admin-homes.component.sass'],
    standalone: false
})
export class AdminHomesComponent implements OnInit {
  homeTabs: HomeTab[] = [];

  constructor(
    private api: MasterApiService,
    private translationService: TranslateService,
  ) { }

  ngOnInit(): void {
    const userHomeList = this.api.auth.userValue?.homeList ?? [];

    this.homeTabs = EHomeValues
      .filter(home => userHomeList.includes(home.id))
      .map(home => ({
        id: home.id,
        name: home.name,
        title: this.translationService.instant(`enumeration.EHomeValues.${home.name}`),
        component: HOME_COMPONENTS[home.name],
      }));
  }
}
